<template>
  <main class="main-fund-quote">
    <navigation-bar :arrMenu="arrMenu" v-if="arrMenu" />
    <router-view
      @current-scroll="value => currentScroll = value"
      v-if="detail"
      :detail="detail"
      :id="detail.id"
    />
    <div v-else></div>
  </main>
</template>
<script>
import NavigationBar from "../../../components/miniapp/global/NavigationBar.vue";
import { mapActions } from "vuex";
export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME
    };
  },
  components: {
    NavigationBar
  },
  data() {
    return {
      id: null,
      name: null,
      detail: null,
      arrMenu: [],
      title: "",
      currentScroll: 0
    };
  },
  async mounted() {
    this.id = this.$route.query.id;
    this.name = this.$route.query.name;

    if (this.id) {
      this.detail = await this.findFundDetail(this.id);
    } else if (this.name) {
      this.detail = await this.findFundDetailByName(this.name);
    }

    if (this.detail) {
      this.arrMenu = [
        {
          route_name: "miniapp-fund-quote-overview",
          route_obj: {
            name: "miniapp-fund-quote-overview",
            query: { id: this.detail.id }
          },
          name: "OVERVIEW",
          route_replace: true,
          route_scroll: 0
        },
        {
          route_name: "miniapp-fund-quote-performance",
          route_obj: {
            name: "miniapp-fund-quote-performance",
            query: { id: this.detail.id }
          },
          name: "RETURN",
          route_replace: true,
          route_scroll: 0
        },
        {
          route_name: "miniapp-fund-quote-portfolio",
          route_obj: {
            name: "miniapp-fund-quote-portfolio",
            query: { id: this.detail.id }
          },
          name: "PORT",
          route_replace: true,
          route_scroll: 0
        },
        {
          route_name: "miniapp-fund-quote-fees",
          route_obj: {
            name: "miniapp-fund-quote-fees",
            query: { id: this.detail.id }
          },
          name: "FEES",
          route_replace: true,
          route_scroll: 0
        }
      ];
    }
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      this.id = newRoute.query.id;
      this.arrMenu
        .filter(item => item.route_name === oldRoute.name)
        .map(item => (item.route_scroll = this.currentScroll));
    },
    async id(v) {
      if (v) {
        this.detail = await this.findFundDetail(v);
        this.arrMenu = [
          {
            route_name: "miniapp-fund-quote-overview",
            route_obj: {
              name: "miniapp-fund-quote-overview",
              query: { id: v }
            },
            name: "OVERVIEW",
            route_replace: true,
            route_scroll: 0
          },
          {
            route_name: "miniapp-fund-quote-performance",
            route_obj: {
              name: "miniapp-fund-quote-performance",
              query: { id: v }
            },
            name: "RETURN",
            route_replace: true,
            route_scroll: 0
          },
          {
            route_name: "miniapp-fund-quote-portfolio",
            route_obj: {
              name: "miniapp-fund-quote-portfolio",
              query: { id: v }
            },
            name: "PORT",
            route_replace: true,
            route_scroll: 0
          },
          {
            route_name: "miniapp-fund-quote-fees",
            route_obj: { name: "miniapp-fund-quote-fees", query: { id: v } },
            name: "FEES",
            route_replace: true,
            route_scroll: 0
          }
        ];

        this.detail ? (this.title = this.detail.short_code) : (this.title = "");
      }
    },
    async name(v) {
      if(v){
        this.detail = await this.findFundDetailByName(v);
        this.detail ? (this.title = this.detail.short_code) : (this.title = "");
      }
    }
  },
  methods: {
    ...mapActions("fund", ["findFundDetail", "findFundDetailByName"])
  }
};
</script>
<style lang="scss" scoped>
</style>